export default __webpack_public_path__ + "static/media/sluch-hlaskovani.c96b60f3.svg";